module.exports = __webpack_public_path__ + "img/create.6991f080.svg";